import styled from 'styled-components';
import { Full } from './full';

export const Root = styled(Full)`
  padding: 10px;
`;
